<!-- Compiled at 2026-10-07T06:21:14.844Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Toolbox-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]="'All employees\' personal development'"
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="content"
								data-defined-in="Toolbox.GoalSettingsPerCycle"
							>
								<div
									class="layout-block vertical"
									[style.align-items]="'inherit'"
									[style.gap]="'1em'"
								>
									<ng-container *ngIf="screen.allCycles"
										><div
											class="layout-block vertical"
											[style.align-items]="'inherit'"
											[style.gap]="'1em'"
										>
											<div
												class="layout-block"
												[style.align-items]="'inherit'"
												[class.grid-horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
												[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
												[style.--layout-column-count]="3"
												[style.gap]="'1em'"
											>
												<mat-form-field
													class="has-selectionChange-handler"
													appearance="fill"
													[style.grid-column]="'span ' + (1)"
													(selectionChange)="handler_DropdownBlock_61_selectionChange_reloadGsList_0($event, { $disabled: $disabled })"
												>
													@let $fc_61_1 = getFormControl(screen,
													'selectedCycle', 61, $scope, $formDirective,
													$disabled, $ignoreValidations);

													<mat-label
														[innerHtml]="'Goal setting period' | escapeHtml"
													></mat-label>
													<mat-select
														class="has-selectionChange-handler"
														(selectionChange)="handler_DropdownBlock_61_selectionChange_reloadGsList_0($event, { $disabled: $disabled })"
														[formControl]="$fc_61_1"
														[compareWith]="$compare"
														#select_61="matSelect"
														[lgFormComponent]="select_61"
														[lgFormValue]="screen.selectedCycle"
														canSelectNullableOptions
														[multiple]="false"
													>
														@let emptyOption_61 = null; @if
														(emptyOption_61) {
														<mat-option [value]="emptyOption_61[0]"
															>{{ emptyOption_61[1] }}</mat-option
														>
														}

														<mat-option
															*ngFor="let $option of (screen.allCycles); let $index = index"
															[value]="$option"
														>
															<span
																[innerHtml]="$option.getDateRange() | escapeHtml"
																style="margin: auto 0"
															></span>
														</mat-option>
													</mat-select>
												</mat-form-field>
												<mat-form-field
													*ngIf="$any(screen.selectedCycle)?.$isOther"
												>
													@let $fc_61_3 =
													getFormControl(screen.selectedCycle,
													'$otherValue', 61, $scope, $formDirective,
													$disabled, $ignoreValidations);
													<mat-label
														[innerHtml]="'Goal setting period' + ' (Other)' | escapeHtml"
													></mat-label>
													<input
														type="text"
														matInput
														[formControl]="$fc_61_3"
													/>
												</mat-form-field>
											</div></div
									></ng-container>

									<ng-container *ngIf="screen.gsList"
										><div
											class="layout-block"
											[style.align-items]="'inherit'"
											[class.grid-horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
											[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
											[style.--layout-column-count]="2"
											[style.gap]="'1em'"
										>
											<mat-card [style.grid-column]="'span ' + (1)">
												<mat-card-header>
													<mat-card-title
														><span
															[innerHtml]="'Timeline' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span
													></mat-card-title>
												</mat-card-header>

												<mat-card-content>
													<ng-container *ngIf="screen.timelineChart">
														<div
															*ngIf="(screen.timelineChart) as $config"
															style="height: 15em; width: 98%"
														>
															<canvas
																baseChart
																class="chart"
																[data]="$config.data"
																[type]="$config.type"
																[options]="$config.options"
																[plugins]="$config.plugins"
															>
															</canvas>
														</div>
													</ng-container>
												</mat-card-content>
											</mat-card>
											<mat-card [style.grid-column]="'span ' + (1)">
												<mat-card-header>
													<mat-card-title
														><span
															[innerHtml]="'Statistics' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span
													></mat-card-title>
												</mat-card-header>

												<mat-card-content>
													<div
														*ngIf="(screen.statusChart) as $config"
														style="height: 250px; width: 350px"
													>
														<canvas
															baseChart
															class="chart"
															[data]="$config.data"
															[type]="$config.type"
															[options]="$config.options"
															[plugins]="$config.plugins"
														>
														</canvas>
													</div>
												</mat-card-content>
											</mat-card>
										</div>
										<mat-card>
											<mat-card-header>
												<mat-card-title
													><span
														[innerHtml]="'Actions for all employees' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span
												></mat-card-title>
											</mat-card-header>

											<mat-card-content>
												<div
													class="layout-block"
													[style.align-items]="'inherit'"
													[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
													[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
													[style.gap]="'1em'"
												>
													<button
														mat-raised-button
														class="has-click-handler"
														color="primary"
														(click)="handler_ButtonBlock_125_click_$adhoc_0($event, { $disabled: $disabled })"
														[disabled]="$disabled"
													>
														<mat-icon>{{'start'}}</mat-icon
														><span
															[innerHtml]="'Start process at goal setting' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</button>
													<button
														mat-raised-button
														class="has-click-handler"
														color="basic"
														(click)="handler_ButtonBlock_127_click_$adhoc_0($event, { $disabled: $disabled })"
														[disabled]="$disabled"
													>
														<mat-icon>{{'thumbs_up_down'}}</mat-icon
														><span
															[innerHtml]="'Start process at self review' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</button>
													<button
														mat-raised-button
														class="has-click-handler"
														color="basic"
														(click)="handler_ButtonBlock_126_click_$adhoc_0($event, { $disabled: $disabled })"
														[disabled]="$disabled"
													>
														<mat-icon>{{'thumbs_up_down'}}</mat-icon
														><span
															[innerHtml]="'Move employees in status &quot;goals approved&quot; to self review phase' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</button>
												</div>
											</mat-card-content>
										</mat-card>
										<mat-card>
											<mat-card-header>
												<mat-card-title
													><span
														[innerHtml]="'All employees\' personal development' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span
												></mat-card-title>
											</mat-card-header>

											<mat-card-content>
												<lowgile-table
													#datatable_75
													[dataSignal]="_DataTableBlock_collectionCodeSignal_75(datatable_75, { app, screen, $pathSegments, $disabled })"
													[trackBy]="trackByAutomatic"
													[columns]="_DataTableBlock_columns_75(screen)"
													[showSettings]="false"
													[userDefinedConfiguration]="undefined"
													[usePaging]="true"
													[pageSize]="20"
													[pageSizeOptions]="[10, 20, 50]"
													[useGlobalFilter]="false"
													[debouncingDelay]="250"
													[stickyHeader]="true"
													[additionalFindOptions]="null"
													[additionalHeaderRows]="[]"
													[additionalFooterRows]="[]"
													[allClasses]="$Modules"
													[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
													[surroundingScope]="$scope"
													#$table_75="lowgileTable"
												>
													<ng-container
														[lowgile-column]="'column_76'"
														[columnValueFn]="_DataTableColumnBlock_sortAndFilter_76_76({ app, screen, $pathSegments, $disabled })"
													>
														<th
															mat-header-cell
															*matHeaderCellDef
															[mat-sort-header]="'column_76'"
														>
															<span
																[innerHtml]="'Goal setting' | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</th>
														<td
															mat-cell
															*matCellDef="let item; let itemIndex = index"
															[attr.data-label]="'Goal setting'"
														>
															<ng-container
																*lowgileScope="item; as: 'item'; let $scope"
															>
																<ng-container
																	*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
																>
																	<ng-container
																		*ngIf="item.gs; else else89"
																		><div
																			class="layout-block"
																			[style.align-items]="'inherit'"
																			[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
																			[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
																			[style.gap]="'1em'"
																		>
																			<a
																				routerLink="/GoalSettingEdit"
																				[queryParams]="{ id: item.gs.id }"
																				routerLinkActive="is-current-link"
																				target="_self"
																			>
																				<span
																					[innerHtml]="item.gs.id | escapeHtml: 'none' | replaceNewlines: 'span'"
																				></span>
																			</a>
																			<button
																				mat-icon-button
																				mat-small-icon-button
																				class="has-click-handler"
																				color="warn"
																				(click)="handler_ButtonBlock_152_click_$adhoc_0($event, { item, itemIndex, $disabled: $disabled })"
																				[disabled]="$disabled"
																			>
																				<mat-icon
																					>{{'delete'}}</mat-icon
																				>
																			</button>
																		</div></ng-container
																	>
																	<ng-template #else89>
																		<div
																			class="layout-block"
																			[style.align-items]="'inherit'"
																			[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
																			[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
																			[style.gap]="'1em'"
																		>
																			<button
																				mat-raised-button
																				class="has-click-handler"
																				color="primary"
																				(click)="handler_ButtonBlock_94_click_$adhoc_0($event, { item, itemIndex, $disabled: $disabled })"
																				[disabled]="$disabled"
																			>
																				<mat-icon
																					>{{'start'}}</mat-icon
																				><span
																					[innerHtml]="'Start at goal setting' | escapeHtml: 'none' | replaceNewlines: 'span'"
																				></span>
																			</button>
																		</div>
																	</ng-template>
																</ng-container>
															</ng-container>
														</td>
													</ng-container>
													<ng-container
														[lowgile-column]="('column_76') + '$$filter'"
													>
														<th mat-header-cell *matHeaderCellDef></th>
													</ng-container>

													<ng-container
														[lowgile-column]="'column_106'"
														[columnValueFn]="_DataTableColumnBlock_sortAndFilter_106_106({ app, screen, $pathSegments, $disabled })"
													>
														<th
															mat-header-cell
															*matHeaderCellDef
															[mat-sort-header]="'column_106'"
														>
															<span
																[innerHtml]="'Self-review' | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</th>
														<td
															mat-cell
															*matCellDef="let item; let itemIndex = index"
															[attr.data-label]="'Self-review'"
														>
															<ng-container
																*lowgileScope="item; as: 'item'; let $scope"
															>
																<ng-container
																	*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
																>
																	<ng-container
																		*ngIf="item.gs; else else117"
																		><ng-container
																			*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(!item.gs.status.isGoalsApproved)) as $disabled"
																		>
																			<button
																				mat-raised-button
																				class="has-click-handler"
																				color="basic"
																				(click)="handler_ButtonBlock_119_click_$adhoc_0($event, { item, itemIndex, $disabled: $disabled })"
																				[disabled]="$disabled"
																			>
																				<mat-icon
																					>{{'thumbs_up_down'}}</mat-icon
																				><span
																					[innerHtml]="'Move to self review phase' | escapeHtml: 'none' | replaceNewlines: 'span'"
																				></span>
																			</button> </ng-container
																	></ng-container>
																	<ng-template #else117>
																		<div
																			class="layout-block"
																			[style.align-items]="'inherit'"
																			[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
																			[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
																			[style.gap]="'1em'"
																		>
																			<button
																				mat-raised-button
																				class="has-click-handler"
																				color="basic"
																				(click)="handler_ButtonBlock_122_click_$adhoc_0($event, { item, itemIndex, $disabled: $disabled })"
																				[disabled]="$disabled"
																			>
																				<mat-icon
																					>{{'thumbs_up_down'}}</mat-icon
																				><span
																					[innerHtml]="'Start at self review' | escapeHtml: 'none' | replaceNewlines: 'span'"
																				></span>
																			</button>
																		</div>
																	</ng-template>
																</ng-container>
															</ng-container>
														</td>
													</ng-container>
													<ng-container
														[lowgile-column]="('column_106') + '$$filter'"
													>
														<th mat-header-cell *matHeaderCellDef></th>
													</ng-container>

													<ng-container
														[lowgile-column]="'gs.employee.name'"
														[columnValueFn]="_DataTableColumnBlock_sortAndFilter_81_81({ app, screen, $pathSegments, $disabled })"
													>
														<th
															mat-header-cell
															*matHeaderCellDef
															[mat-sort-header]="'gs.employee.name'"
														>
															<span
																[innerHtml]="'Employee' | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</th>
														<td
															mat-cell
															*matCellDef="let item; let itemIndex = index"
															[attr.data-label]="'Employee'"
														>
															<ng-container
																*lowgileScope="item; as: 'item'; let $scope"
															>
																<ng-container
																	*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
																>
																	<span
																		[innerHtml]="_DataTableColumnBlock_cellText_81({ app, screen, $pathSegments, $disabled, item, itemIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
																	></span>
																</ng-container>
															</ng-container>
														</td>
													</ng-container>
													<ng-container
														[lowgile-column]="('gs.employee.name') + '$$filter'"
													>
														<th mat-header-cell *matHeaderCellDef></th>
													</ng-container>

													<ng-container
														[lowgile-column]="'user.manager.name'"
														[columnValueFn]="_DataTableColumnBlock_sortAndFilter_139_139({ app, screen, $pathSegments, $disabled })"
													>
														<th
															mat-header-cell
															*matHeaderCellDef
															[mat-sort-header]="'user.manager.name'"
														>
															<span
																[innerHtml]="'Manager for performance development' | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</th>
														<td
															mat-cell
															*matCellDef="let item; let itemIndex = index"
															[attr.data-label]="'Manager for performance development'"
														>
															<ng-container
																*lowgileScope="item; as: 'item'; let $scope"
															>
																<ng-container
																	*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
																>
																	<ng-container
																		*ngIf="screen.editManagerForUser?.id !== item.user.id || screen.editManagerType != 'gs'; else else141"
																		><div
																			class="layout-block"
																			[style.align-items]="'inherit'"
																			[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
																			[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
																			[style.gap]="'1em'"
																		>
																			<ng-container
																				*ngIf="item.gs?.manager?.userId; else else143"
																				><span
																					[style.flex]="'1 0 auto'"
																					[innerHtml]="item.gs.manager.name | escapeHtml: 'none' | replaceNewlines: 'span'"
																				></span>
																				<button
																					mat-icon-button
																					mat-small-icon-button
																					class="has-click-handler"
																					color="basic"
																					(click)="handler_ButtonBlock_147_click_$adhoc_0($event, { item, itemIndex, $disabled: $disabled })"
																					[disabled]="$disabled"
																				>
																					<mat-icon
																						>{{'edit'}}</mat-icon
																					>
																				</button></ng-container
																			>
																			<ng-template #else143>
																				<span
																					style="
																						font-style: italic;
																					"
																					[style.flex]="'1 0 auto'"
																					[innerHtml]="'(no manager set)' | escapeHtml: 'none' | replaceNewlines: 'span'"
																				></span>
																			</ng-template></div
																	></ng-container>
																	<ng-template #else141>
																		@let $fc_149_1 =
																		getFormControl(screen,
																		'editManagerGs', 149,
																		$scope, $formDirective,
																		$disabled,
																		$ignoreValidations); @let
																		displayWith_149 =
																		_SearchableDropdownBlock_displayWith_149;
																		<lowgile-searchable-dropdown
																			class="has-optionSelected-handler"
																			appearance="fill"
																			(optionSelected)="handler_SearchableDropdownBlock_149_optionSelected_$adhoc_0($event, { item, itemIndex, $disabled: $disabled })"
																			[data]="_SearchableDropdownBlock_collectionCode_149($scope)"
																			[trackBy]="trackByAutomatic"
																			[label]="'Manager'"
																			[formControl]="$fc_149_1"
																			bindingMode="object"
																			[entity]=""
																			[minSearchLength]="0"
																			[maxResults]="20"
																			[displayWith]="displayWith_149"
																			[displayWithContext]="$scope"
																			[debouncingDelayMs]="0"
																			[findOptions]="null"
																			[allowClearing]="false"
																			[allClasses]="$Modules"
																			[emptySelection]="undefined"
																			[itemTemplate]="itemTemplate_149"
																		></lowgile-searchable-dropdown>
																		<ng-template
																			#itemTemplate_149
																			let-$option
																			let-$index="$index"
																		>
																			{{
																			displayWith_149($option,
																			$index, $scope) }}
																		</ng-template>
																	</ng-template>
																</ng-container>
															</ng-container>
														</td>
													</ng-container>
													<ng-container
														[lowgile-column]="('user.manager.name') + '$$filter'"
													>
														<th mat-header-cell *matHeaderCellDef></th>
													</ng-container>

													<ng-container
														[lowgile-column]="'gs.manager.name'"
														[columnValueFn]="_DataTableColumnBlock_sortAndFilter_82_82({ app, screen, $pathSegments, $disabled })"
													>
														<th
															mat-header-cell
															*matHeaderCellDef
															[mat-sort-header]="'gs.manager.name'"
														>
															<span
																[innerHtml]="'Line manager' | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</th>
														<td
															mat-cell
															*matCellDef="let item; let itemIndex = index"
															[attr.data-label]="'Line manager'"
														>
															<ng-container
																*lowgileScope="item; as: 'item'; let $scope"
															>
																<ng-container
																	*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
																>
																	<ng-container
																		*ngIf="screen.editManagerForUser?.id !== item.user.id || screen.editManagerType != 'line'; else else130"
																		><div
																			class="layout-block"
																			[style.align-items]="'inherit'"
																			[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
																			[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
																			[style.gap]="'1em'"
																		>
																			<ng-container
																				*ngIf="item.user.manager?.id; else else136"
																				><span
																					[style.flex]="'1 0 auto'"
																					[innerHtml]="item.user.manager?.getName() ?? '' | escapeHtml: 'none' | replaceNewlines: 'span'"
																				></span>
																				<ng-container
																					*ngIf="item.user.manager?.id != item.gs?.manager?.userId && item.gs?.manager"
																					><mat-icon
																						style="
																							color: orange;
																						"
																						[title]="'Different from assigned personal development manager'"
																						[innerHtml]="'warning'"
																						fontSet="material-icons"
																						[inline]="false"
																					></mat-icon
																				></ng-container>
																			</ng-container>
																			<ng-template #else136>
																				<span
																					style="
																						color: red;
																						font-style: italic;
																					"
																					[style.flex]="'1 0 auto'"
																					[innerHtml]="'(no line manager set)' | escapeHtml: 'none' | replaceNewlines: 'span'"
																				></span>
																			</ng-template>
																			<button
																				mat-icon-button
																				mat-small-icon-button
																				class="has-click-handler"
																				color="basic"
																				(click)="handler_ButtonBlock_134_click_$adhoc_0($event, { item, itemIndex, $disabled: $disabled })"
																				[disabled]="$disabled"
																			>
																				<mat-icon
																					>{{'edit'}}</mat-icon
																				>
																			</button>
																		</div></ng-container
																	>
																	<ng-template #else130>
																		@let $fc_132_1 =
																		getFormControl(screen,
																		'editManagerGs', 132,
																		$scope, $formDirective,
																		$disabled,
																		$ignoreValidations); @let
																		displayWith_132 =
																		_SearchableDropdownBlock_displayWith_132;
																		<lowgile-searchable-dropdown
																			class="has-optionSelected-handler"
																			appearance="fill"
																			(optionSelected)="handler_SearchableDropdownBlock_132_optionSelected_$adhoc_0($event, { item, itemIndex, $disabled: $disabled })"
																			[data]="_SearchableDropdownBlock_collectionCode_132($scope)"
																			[trackBy]="trackByAutomatic"
																			[label]="'Manager'"
																			[formControl]="$fc_132_1"
																			bindingMode="object"
																			[entity]=""
																			[minSearchLength]="0"
																			[maxResults]="20"
																			[displayWith]="displayWith_132"
																			[displayWithContext]="$scope"
																			[debouncingDelayMs]="0"
																			[findOptions]="null"
																			[allowClearing]="false"
																			[allClasses]="$Modules"
																			[emptySelection]="undefined"
																			[itemTemplate]="itemTemplate_132"
																		></lowgile-searchable-dropdown>
																		<ng-template
																			#itemTemplate_132
																			let-$option
																			let-$index="$index"
																		>
																			{{
																			displayWith_132($option,
																			$index, $scope) }}
																		</ng-template>
																	</ng-template>
																</ng-container>
															</ng-container>
														</td>
													</ng-container>
													<ng-container
														[lowgile-column]="('gs.manager.name') + '$$filter'"
													>
														<th mat-header-cell *matHeaderCellDef></th>
													</ng-container>

													<ng-container [lowgile-column]="'gs.status$id'">
														<th mat-header-cell *matHeaderCellDef>
															<span
																[innerHtml]="'Personal Development status' | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</th>
														<td
															mat-cell
															*matCellDef="let item; let itemIndex = index"
															[attr.data-label]="'Personal Development status'"
														>
															<ng-container
																*lowgileScope="item; as: 'item'; let $scope"
															>
																<ng-container
																	*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
																>
																	<span
																		[innerHtml]="_DataTableColumnBlock_cellText_83({ app, screen, $pathSegments, $disabled, item, itemIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
																	></span>
																</ng-container>
															</ng-container>
														</td>
													</ng-container>
													<ng-container
														[lowgile-column]="('gs.status$id') + '$$filter'"
													>
														<th mat-header-cell *matHeaderCellDef></th>
													</ng-container>
												</lowgile-table>
											</mat-card-content> </mat-card
									></ng-container>
								</div>
							</div>
						</ng-container>
					</ng-template>
				</Toolbox-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
